



















































































declare var window: any;
import { vxm } from '../store.vuex';
import { Component, Vue } from 'vue-property-decorator';
import router from '../router';
import { UserProfile } from '@/models/userdata/profile';
import { SkillDocWrapper } from '@/models/skills/skilldocwrapper';
import { UserJob } from '@/models/jobs/userjob';
import { Job } from '@/models/jobs/job';
import { JobSkillType } from '@/models/skills/JobSkillType';
import { SkillType } from '@/models/userdata/skilltype';

@Component({
  name: 'JobApplicationSuccess',
  components: {},
})
export default class JobApplicationSuccess extends Vue {
  private userProfile: UserProfile = new UserProfile();
  public userSkills: SkillDocWrapper[] = [];
  public userJob: UserJob = new UserJob();
  private jobDetail: any[] = [];
  private jobDetailsError: string = '';
  public anonymousJob: Job = new Job();
  public jobSkills: string[] = [];
  public skillsNotExists: string[] = [];
  private jobSkillTypes: JobSkillType[] = [];
  private dbJobSkillTypes: SkillType[] = [];
  $wlToastr: any;

  async mounted() {
    this.jobDetails();
  }

  get canShowJobSkillTypes() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      //return vxm.configs.ClientConfigs.userProfileConfig.profileSections.find(
      //  (option) => option.sectionKey === 'SKILLS_AND_SPECIALITY',
      //);
      return vxm.configs.ClientConfigs.userProfileConfig.profileSections.find(option => option.sectionKey === 'SKILLS');
    }
    if (
      vxm.jobs.BrandingInfo.PROFILE_ACCORDIONS &&
      vxm.jobs.BrandingInfo.PROFILE_ACCORDIONS.includes('skills')
    ) {
      return this.jobSkillTypes.length > 0;
    } else if (!vxm.jobs.BrandingInfo.PROFILE_ACCORDIONS) {
      return this.jobSkillTypes.length > 0;
    } else {
      return false;
    }
  }

  jobDetails() {
    let p: Promise<any> = vxm.users.isLoggedIn
      ? vxm.jobs.getJobByID(this.JobID() + '')
      : vxm.jobs.getAnonymousJobByID(this.JobID() + '');

    return p.then((resp) => {
      if (resp.jobPostingErrors && resp.jobPostingErrors[0]) {
        this.jobDetailsError = resp.jobPostingErrors[0].jobPostingErrorMessage;
        if(resp.jobPostingErrors[0].jobPostingErrorCode == 1121){
          this.jobDetailsError = this.$t('errorcode.1121').toString();
        }
        if(resp.jobPostingErrors[0].jobPostingErrorCode == 1122){
          this.jobDetailsError = this.$t('errorcode.1122').toString();
        }
        if(resp.jobPostingErrors[0].jobPostingErrorCode == 1127){
          this.jobDetailsError = this.$t('errorcode.1127').toString();
        }
        if(resp.jobPostingErrors[0].jobPostingErrorCode == 1128){
          this.jobDetailsError = this.$t('errorcode.1128').toString();
        }
        if(resp.jobPostingErrors[0].jobPostingErrorCode == 1123){
          this.jobDetailsError = this.$t('errorcode.1123').toString();
        }
        if(resp.jobPostingErrors[0].jobPostingErrorCode == 1129){
          this.jobDetailsError = this.$t('errorcode.1129').toString();
        }
        if(resp.jobPostingErrors[0].jobPostingErrorCode == 1124){
          this.jobDetailsError = this.$t('errorcode.1124').toString();
        }
        return;
      }

      const jInfo: Job[] = [];
      jInfo.push(vxm.jobs.AnonymousJobByID);
      jInfo.forEach((job) =>
        job.savedDTTM ? (job.bookmarkStatus = 'A') : (job.bookmarkStatus = 'D'),
      );
      this.jobDetail = jInfo;
      this.jobDetail[0].jobSkills.forEach((item, index) => {
        this.jobSkills.push(item);
      });
      this.getUserSkillsnotSelected();
    });
  }

  async getUserSkillsnotSelected() {
    console.log('job id:' + vxm.jobs.AppliedJob);
    this.userJob = vxm.jobs.UserJob;
    this.userProfile = vxm.users.myUserProfile;
    this.userSkills = this.userProfile.skillTypes;

    const respPromise: any = await vxm.skills.getUserSkillsForJobSkills(
      this.jobSkills,
    );
    if (respPromise.meta.success) {
      this.dbJobSkillTypes = respPromise.data;
    }

    this.dbJobSkillTypes.forEach((item, index) => {
      let skillExist = false;
      if (this.userSkills != null) {
        this.userSkills.forEach((userSkill, index) => {
          if (userSkill.skillType.skillTypeId == item.skillTypeId) {
            skillExist = true;
          }
        });
      }
      if (!skillExist) {
        var jobSkillType = new JobSkillType();
        jobSkillType.skillTypeId = item.skillTypeId;
        jobSkillType.skillTypeName = item.skillTypeName;
        this.jobSkillTypes.push(jobSkillType);
      }
    });

    this.jobSkillTypes.forEach((item, index) => {
      console.log(
        'job skill added to screen:' +
          item.skillTypeName +
          ' selected:' +
          item.selected,
      );
    });
  }

  async activateSkill(jobSkillType: JobSkillType) {
    const vm = this;
    const sdw = new SkillDocWrapper();
    sdw.skillType.skillTypeId = jobSkillType.skillTypeId;
    sdw.skillType.skillTypeName = jobSkillType.skillTypeName;
    if (this.userProfile.skillTypes == null) {
      let tempSkillTypes: SkillDocWrapper[] = [];
      tempSkillTypes.push(sdw);
      this.userProfile.skillTypes = tempSkillTypes;
    } else {
      this.userProfile.skillTypes.push(sdw);
    }
    const respPromise: any = vxm.users.addSkillsToUserProfile(vm.userProfile);
    const resp = await respPromise;
    if (resp.success) {
      this.jobSkillTypes.forEach((item, index) => {
        if (item.skillTypeId == jobSkillType.skillTypeId) {
          item.selected = true;
          console.log('selected job skill:' + item.skillTypeId);
        }
      });
      vm.$wlToastr(
        'success',
        jobSkillType.skillTypeName +
          ' Skill successfully added to your profile',
        vm.$t('MyJobListing_JobApplication'),
      );
    } else {
      vm.$wlToastr('error', 
        vm.$t('skill-selection-error-message'), 
        vm.$t('MyJobListing_JobApplication'));
    }
  }

  deleteSkill(skillTypeId: number) {
    const vm = this;
    const respPromise: any = vxm.skills.deleteSkillTypeId(skillTypeId);
    Promise.all([respPromise]).then((values) => {
      if (!values[0].success) {
        vm.$wlToastr('error', vm.$t('unable-to-delete-skill-err-msg'), vm.$t('MyJobListing_JobApplication'));
      } else {
        this.userProfile.skillTypes.forEach((item, index) => {
          if (item.skillType.skillTypeId === skillTypeId)
            this.userProfile.skillTypes.splice(index, 1);
        });

        this.jobSkillTypes.forEach((item, index) => {
          if (item.skillTypeId == skillTypeId) {
            item.selected = false;
            console.log('setting deselected job skill to :' + item.skillTypeId);
          }
        });

        vm.$wlToastr(
          'success',
          vm.$t('skill-deleted-success-msg'),
          vm.$t('MyJobListing_JobApplication'),
        );
      }
    });
  }

  JobID() {
    return parseInt(vxm.jobs.AppliedJob, 10);
  }
}
